export default __webpack_public_path__ + "static/media/Calibre-Semibold.6d384f10.woff";